/*
 * Copyright (c) 2019 Cédric Bodet.
 * The MIT License
 * http://www.opensource.org/licenses/mit-license
 */
import 'worldwindjs' //WorldWind global
import EnhancedWmsLayer from '../../globe/api/EnhancedWmsLayer'

/* global WorldWind */

export default class EoxLabels extends EnhancedWmsLayer {
    constructor() {
        let cfg = {
            title: "Map Labels",
            service: "https://tiles.maps.eox.at/wms",
            version: "1.3.0",
            layerNames: "overlay",
            styleNames: "" // (optional): {String} A comma separated list of the styles to include in this layer.</li>
        };
        super(cfg);

        // Make this layer opaque
        this.opacity = 1.0;

        this.urlBuilder.transparent = false;
    }

    doRender(dc) {
        super.doRender(dc);
        if (this.inCurrentFrame) {
            dc.screenCreditController.addCredit(
                "Data © OpenStreetMap contributors, Rendering © EOX and MapServer",
                WorldWind.Color.LIGHT_GRAY);
        }
    }
}
